'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const QuickActions = () => {
  const actions = [
    {
      label: 'Compare Prices',
      description: 'See dealership vs independent pricing',
      icon: 'ChartBarIcon',
      href: '/price-compare',
      color: 'bg-accent/10 text-accent hover:bg-accent/20'
    },
    {
      label: 'Find OEM Parts',
      description: 'AI-powered parts recommendations',
      icon: 'WrenchScrewdriverIcon',
      href: '/oem-parts-finder',
      color: 'bg-primary/10 text-primary hover:bg-primary/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {actions.map((action) => (
        <Link
          key={action.href}
          href={action.href}
          className={`flex items-center space-x-4 rounded-xl p-6 transition-smooth active:scale-[0.97] ${action.color}`}
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-card shadow-elevation-sm flex-shrink-0">
            <Icon name={action.icon as any} size={24} />
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-base font-semibold mb-1">
              {action.label}
            </h3>
            <p className="font-body text-sm opacity-80">
              {action.description}
            </p>
          </div>
          <Icon name="ChevronRightIcon" size={20} className="flex-shrink-0" />
        </Link>
      ))}
    </div>
  );
};

export default QuickActions;